import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import ChangePasswordForm from './ChangePasswordForm';
import AccountEditForm from './AccountEditForm';
import WarehouseDeliveryRequestsPage from './pages/WarehouseDeliveryRequestsPage';
import WarehouseItemsPage from './pages/WarehouseItemsPage';
import NavBar from './NavBar';
import DrawerMenu from './DrawerMenu';
import NotFoundPage from './NotFoundPage';
import Auth from './Auth';
var RouteElement = function (_a) {
    var element = _a.element;
    var _b = React.useState(false), menuOpen = _b[0], setMenuOpen = _b[1];
    var handleClickMenu = React.useCallback(function () {
        setMenuOpen(!menuOpen);
    }, [menuOpen, setMenuOpen]);
    var handleCloseMenu = React.useCallback(function () {
        setMenuOpen(false);
    }, [setMenuOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(NavBar, { role: "warehouse", onClickMenu: handleClickMenu }),
        React.createElement(DrawerMenu, { role: "warehouse", open: menuOpen, onClose: handleCloseMenu }),
        React.createElement("main", null,
            React.createElement(React.Fragment, null, element))));
};
var RouteElementWithAuth = function (_a) {
    var element = _a.element;
    return (React.createElement(Auth, { role: "warehouse" },
        React.createElement(RouteElement, { element: element })));
};
var WarehouseRouter = function () {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "login", element: React.createElement(RouteElement, { element: React.createElement(LoginForm, { role: "warehouse" }) }) }),
        React.createElement(Route, { path: "password/reset", element: React.createElement(RouteElement, { element: React.createElement(ResetPasswordForm, { role: "warehouse" }) }) }),
        React.createElement(Route, { path: "password/edit", element: React.createElement(RouteElement, { element: React.createElement(ChangePasswordForm, { role: "warehouse" }) }) }),
        React.createElement(Route, { path: "account/edit", element: React.createElement(RouteElementWithAuth, { element: React.createElement(AccountEditForm, { role: "warehouse" }) }) }),
        React.createElement(Route, { path: "items", element: React.createElement(RouteElementWithAuth, { element: React.createElement(WarehouseItemsPage, null) }) }),
        React.createElement(Route, { path: "/", element: React.createElement(RouteElementWithAuth, { element: React.createElement(WarehouseDeliveryRequestsPage, null) }) }),
        React.createElement(Route, { path: "*", element: React.createElement(NotFoundPage, null) })));
};
export default WarehouseRouter;
